import React, { useState } from "react";
import { Send, Mail, Phone, MapPin } from "lucide-react";
import Axios from "axios";
import "../contactform.css";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    service: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value})
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage("");

    try {
      const response = await Axios.post("api/submit", formData);


      if (response.status === 200){

        setSubmitMessage("Thank you for your message! We'll get back to you within 24 hours.");
        setFormData({
        name: "",
        email: "",
        phone: "",
        service: "",
        message: "",
      });
      }

    } catch (error) {
      setSubmitMessage(
        "Sorry, there was an error sending your message. Please try again."
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="contact-section">
      <div className="contact-container">
        <div className="contact-header">
          <h2 className="contact-title">Get Started Today</h2>
          <p className="contact-description">
            Ready to take your business online? Contact us for a free
            consultation and custom quote tailored to your needs.
          </p>
        </div>

        <div className="contact-grid">
          {/* Contact Form */}
          <div className="contact-form-card">
            <div className="contact-form-header">
              <h3 className="contact-form-title">Send us a Message</h3>
              <p className="contact-form-subtitle">
                Fill out the form below and we'll get back to you within 24
                hours.
              </p>
            </div>
            <div className="contact-form-content">
              <form onSubmit= {(e) => handleSubmit(e)} className="contact-form">
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="name" className="form-label">
                      Full Name *
                    </label>
                    <input
                      id="name"
                      type="text"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      className="form-input"
                      placeholder="Your full name"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="email" className="form-label">
                      Email Address *
                    </label>
                    <input
                      id="email"
                      type="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      className="form-input"
                      placeholder="your@email.com"
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="phone" className="form-label">
                      Phone Number
                    </label>
                    <input
                      id="phone"
                      type="tel"
                      value={formData.phone}
                      onChange={handleChange}
                      className="form-input"
                      placeholder="(555) 123-4567"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="service" className="form-label">
                      Service Interested In *
                    </label>
                    <select
                      id="service"
                      value={formData.service}
                      onChange={handleChange}
                      className="form-select"
                      required
                    >
                      <option value="">Select a service</option>
                      <option value="basic-website">
                        Basic Website ($299-$499)
                      </option>
                      <option value="professional-website">
                        Professional Website ($799-$1,299)
                      </option>
                      <option value="premium-website">
                        Premium Website ($1,499-$2,499)
                      </option>
                      <option value="starter-hosting">
                        Starter Hosting ($35.99/month)
                      </option>
                      <option value="business-hosting">
                        Business Hosting ($45.99/month)
                      </option>
                      <option value="pro-hosting">
                        Pro Hosting ($59.99/month)
                      </option>
                      <option value="custom-solution">Custom Solution</option>
                      <option value="consultation">Free Consultation</option>
                    </select>
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="message" className="form-label">
                    Message *
                  </label>
                  <textarea
                    id="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    className="form-textarea"
                    placeholder="Tell us about your project, goals, and any specific requirements..."
                  />
                </div>

                {submitMessage && (
                  <div
                    className={`submit-message ${
                      submitMessage.includes("Thank you") ? "success" : "error"
                    }`}
                  >
                    {submitMessage}
                  </div>
                )}

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="submit-button"
                >
                  {isSubmitting ? "Sending..." : "Send Message"}
                  {!isSubmitting && <Send size={16} />}
                </button>
              </form>
            </div>
          </div>

          {/* Contact Information */}
          <div>
            <div className="contact-info-card">
              <div className="contact-info-header">
                <h3 className="contact-info-title">Contact Information</h3>
                <p className="contact-info-subtitle">
                  Get in touch with us through any of these channels.
                </p>
              </div>
              <div className="contact-info-content">
                <div className="contact-info-item">
                  <div className="contact-info-icon">
                    <Mail size={24} />
                  </div>
                  <div className="contact-info-text">
                    <h3>Email</h3>
                    <p>oighosting29@gmail.com</p>
                  </div>
                </div>

                <div className="contact-info-item">
                  <div className="contact-info-icon">
                    <Phone size={24} />
                  </div>
                  <div className="contact-info-text">
                    <h3>Phone</h3>
                    <p>(312) 597-7347</p>
                  </div>
                </div>

                <div className="contact-info-item">
                  <div className="contact-info-icon">
                    <MapPin size={24} />
                  </div>
                  <div className="contact-info-text">
                    <h3>Location</h3>
                    <p>Serving clients worldwide</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="why-choose-contact-card">
              <div className="why-choose-contact-content">
                <h3 className="why-choose-contact-title">
                  Why Choose OIGHosting?
                </h3>
                <ul className="why-choose-contact-list">
                  <li className="why-choose-contact-item">
                    Free consultation and project assessment
                  </li>
                  <li className="why-choose-contact-item">
                    Transparent pricing with no hidden fees
                  </li>
                  <li className="why-choose-contact-item">
                    24/7 support and maintenance
                  </li>
                  <li className="why-choose-contact-item">
                    99.9% uptime guarantee
                  </li>
                  <li className="why-choose-contact-item">
                    Fast turnaround times
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
